export default {
  // 系统管理员
  admin: "1F6B4B7E-915B-431D-B3B3-8A6DEF1E4699",
  // 医院管理员 
  hosAdmin: "2EC22734-1CB5-4BC0-B361-683A424ADF72",
  // 科室管理员 
  secAdmin: "8926F290-5C7B-42C7-9B1F-ABBA0BF29640",
  // 科主任 
  secDirector: "558F067C-B817-4EFD-A9E9-1C72ED0B0778",
  // 带教老师 
  teacher: "A04ED979-B25B-4067-980C-C2CE5436BED4",
  // 学员 
  stu:"49556BD4-C792-493D-8B51-FD355D6F7AAA",
  // 普通用户 
  normalUser:"B61A6624-B783-4636-9D88-02887FE64532"
}
